export default "__VITE_ASSET__DWmpnQRg__"